import { useMemo } from 'react';

import { HeaderMenuItemFragmentFragment, LinkFragmentFragment } from '../../__generated__/graphql';
import { convertHref } from '../../utils/convertHref';

export const useBreadCrumbMenuItems = ({
  currentUri,
  menuItems,
}: {
  currentUri: string;
  menuItems: HeaderMenuItemFragmentFragment[];
}): LinkFragmentFragment[] => {
  return useMemo(() => {
    const currentHref = convertHref(currentUri);

    const breadCrumbMenuItems: LinkFragmentFragment[] = [];

    for (const menuItem of menuItems) {
      const navDetailsHref = convertHref(menuItem.navDetails?.link?.url);

      for (const segment of menuItem.navSegments?.segments ?? []) {
        for (const link of segment?.links ?? []) {
          const linkHref = convertHref(link?.link?.url);

          if (menuItem.navDetails?.link?.url && link?.link?.url && linkHref === currentHref) {
            breadCrumbMenuItems.push({
              ...menuItem.navDetails.link,
              title: menuItem.label,
              url: navDetailsHref,
            });
            breadCrumbMenuItems.push(link.link);

            break;
          }
        }

        if (breadCrumbMenuItems.length) {
          break;
        }
      }

      if (breadCrumbMenuItems.length) {
        break;
      }
    }

    return breadCrumbMenuItems;
  }, [
    currentUri,
    menuItems,
  ]);
};
